export default function Projects() {
  const capabilities = [
    {
      title: "Project Management",
      description:
        "End-to-end project planning, execution, delivery tracking, stakeholder coordination, and risk management."
    },
    {
      title: "Software Development",
      description:
        "Experience in designing, developing, debugging, maintaining, and enhancing modern software applications."
    },
    {
      title: "Team Leadership",
      description:
        "Leading development teams, coordinating technical work, conducting code reviews, mentoring team members, and supporting delivery."
    },
    {
      title: "Requirements & Client Management",
      description:
        "Working with clients and stakeholders to understand requirements, clarify priorities, and translate business needs into actionable development tasks."
    },
    {
      title: "Agile & Sprint Management",
      description:
        "Sprint planning, task allocation, progress tracking, delivery coordination, and continuous improvement."
    },
    {
      title: "Web Application Development",
      description:
        "Experience with modern web application development using technologies such as Ruby on Rails, React, JavaScript, databases, and cloud platforms."
    },
    {
      title: "Cloud & Infrastructure",
      description:
        "Experience working with cloud technologies and application infrastructure, including Google Cloud Platform and AWS."
    },
    {
      title: "Technical Mentoring",
      description:
        "Supporting developers and freshers through mentoring, technical guidance, onboarding, project reviews, and development practices."
    }
  ];

  return (
    <section id="capabilities">
      <h2>Professional Capabilities</h2>

      <p>
        Harpreet Singh brings experience across project management, software
        development, technical leadership, team coordination, and delivery of
        software solutions.
      </p>

      <div className="cards">
        {capabilities.map((capability, index) => (
          <div className="card" key={index}>
            <h3>{capability.title}</h3>
            <p>{capability.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
